import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { VesignDataService } from 'src/app/service/vesign-data.service';
import { distinct, filter, map, pluck, toArray, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Route, Router, Params } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, BrowserModule } from '@angular/platform-browser';
import { Location } from '@angular/common';
import * as CryptoJS from 'crypto-js';
//import jsPDF from 'jspdf';
//import { debug } from 'console';
declare var $: any;
@Component({
  selector: 'app-partner-cons-list',
  templateUrl: './partner-cons-list.component.html',
  styleUrls: ['./partner-cons-list.component.css']
})
export class PartnerConsListComponent implements OnInit {
  @ViewChild("SelectedPhysicalSignatureDocText") SelectedPhysicalSignatureDocText: ElementRef;
  @ViewChild("SelectedAdditionalDocText") SelectedAdditionalDocText: ElementRef;
  @ViewChild("PhysicalSignaturefileUpload") PhysicalSignaturefileUpload: ElementRef;
  @ViewChild("AdditionalfileUpload") AdditionalfileUpload: ElementRef;
  @ViewChild("SelectedDocText") SelectedDocText: ElementRef;
  @ViewChild("fileUpload") fileUpload: ElementRef;
  @ViewChild('fullName') fullNameInput: any;
  IsPhysicalSignatureTypeValid: boolean = true;
  IsAdditionalDocsTypeValid: boolean = true;
  txtPhysicaleDocumentName: string = "";
  txtAdditionalDocumentName: string = "";
  IsPhysicalSignatureDocNameValid: boolean = true;
  IsAdditionalDocNameValid: boolean = true;
  paramsObject;
  VendorConsultantPackegeList = [];
  ConsultantModifiedList = [];
  ConsultantDocList = [];
  UploadedPhysicalSignatureDoc = [];
  SelectedDocType: string = null;
  IsSupportingTypeValid: boolean = true;
  txtDocumentName: string = "";
  mainDocumentName: string = "";
  mainPhyDocumentName: string = "";
  mainAddDocumentName: string = "";
  DocIdForSupportingDocs: number = 0;
  Search = {
    vendorCode: "",
    taskId: null,
    gcId: null,
    search: null
  }
  envMastIds = [];
  evMastID: number = 0;
  docTypes: any[] = [
    { value: 1, Text: "Copy of I9" },
    { value: 2, Text: "I9 supporting documents" },
    { value: 3, Text: "Paystubs" },
    { value: 4, Text: "E-verification report" },
    { value: 5, Text: "CA tax form" }
  ];
  DocType = "";
  SelectedTaskID: string;
  fileToUpload: File = null;
  PhysicalSignatureDownloadDocList = [];
  AdditionalDocsList = [];
  sampleAddtionalResObj = [];
  UploadedAdditionalDocsList = [];
  IsphysicalSignatureDocsPopupOpen: boolean = false;
  IsAdditionalDocsPopupOpen: boolean = false;
  IsphysicalSignatureDocDelAllDis: boolean = true;
  IsAdditionalDocDelAllDis: boolean = true;
  totalUploadedPhysicalSignatureDocs: number;
  emailWrapStyle = [];
  IsemailWrapPopupOpen: boolean = false;
  PhysicalSignatureStyle: string = "none"
  AdditionalPopupStyle: string = "none";
  SelectedDownloadDocID: any;
  IsItAdhocDocs: string = "";
  IsDragDropBtn: boolean = false;
  IsDragDropBtnForAdditional: boolean = false;
  IsEsign: boolean = false;
  supportingDocStyle: string = "none";
  DocuSignPopupStyle: string = "none";
  InfoPopupForEsign: string = "none";
  IssupportingDocsPopupOpen: boolean = false;
  IsDocuSignPopupOpen: boolean = false;
  IsInfoEsignPopupOpen: boolean = false;
  IsSupportingDocNameValid: boolean = true;
  UploadedSupportingDocs = [];
  totalUploadedSupportingDocs: number;
  totalUploadedSupportingDocsForDocument: number = 0;
  IsSupportingDocDelAllDis: boolean = true;
  totalPendingDocs;
  RejectionInfoPopupOpen: boolean = false;
  RejectionHistory = [];
  RejectionHistoryOPS = [];
  RejectionHistoryCNS = [];
  RejectionInfoPopupclass = '';
  CurrentEsignDocIndex: number = 0;
  CurrentEsignDocLength: number = 0;
  IsReviewDivVisible: boolean = false;
  IsReviewSubDivVisible: boolean = false;
  IsReviewIFrameVisible: boolean = false;
  IsDocSignIFrameVisible: boolean = false;
  DocuSignUrl: SafeResourceUrl;
  DocsUrl: SafeResourceUrl;
  DocHtml: any;
  IsBeginProcess: boolean = false;
  ConsultantReviewDocList = [];
  IsFillableDivVisible: boolean = false;
  forWorkOrderTempValue = { taskId: '', docID: '', docStatus: '', Consultant_Reject: 0, envelop_Pid: 0 }
  RejectPopupclass: string = "";
  IsRejectPopupOpen: boolean = false;
  RejectionNotes: string = "";
  ISRejectAndGoNext: boolean = false;
  SelectedParams = {
    DocId: 0,
    RejectionReason: ''
  };
  ConsultantTempList: any;
  SelectedReviewDocList = [];
  RejectionNotesError: boolean = false;
  IsWorkOrderReviewed: boolean = false;
  DocsReviewedCount: number = 0;
  ReviewDoc: number = 0;
  IsNext: boolean = false;
  PinActiverecords: any = {
    pinID: 0,
    task_id: '',
    envMstrID: '',
    EmailLogId: '',
    IsActive: true,
    Doc_Type: ''
  }
  //use for get completeddocs count
  SearchBy = {
    SearchBySpecificColumns: '',
    Vendor_code: '',
    taskId: null,
  }
  IsSupportingDocsForDocId: boolean = false;
  IsFillableDivVisibleForSP: boolean = false;
  IsFillableDivVisibleForCN: boolean = false;
  IsPin: boolean = false;
  IsExpandFirstRow: boolean = false;
  Mail: any = {
    email_Subject: '',
    email_Body: '',
    email_From: '',
    email_To: '',
    email_CC: '',
    email_BCC: '',
    email_Sent_By: '',
    ActivityName: '',
    omnE_Service: '',
    omnE_Entity: '',
    TaskId: 0,
    email_Template_Id: 0
  };
  constructor(private route: ActivatedRoute, private location: Location, public router: Router, public sanitizer: DomSanitizer, private dataService: VesignDataService<any>, private toastr: ToastrService,
    private spinner: NgxSpinnerService) {
  }
  IsProcessContinue: boolean = false;
  emailsendWrapStyle: string = "";
  ngOnInit() {
    //debugger
    this.spinner.show();
    this.route.queryParamMap.subscribe((params) => {
      this.paramsObject = { ...params.keys, ...params }
      if (this.paramsObject.params.Envelop_Pid != undefined) {
        //debugger
        this.IsProcessContinue = true;
        // this.updateEnvelopStatus(this.paramsObject.params.Envelop_Pid);
        this.dataService.updateStatus(environment.eSignApiUrl + "/api/TakeAction/ReturnMsg?Envelop_Pid=" + this.paramsObject.params.Envelop_Pid)
          .then((res) => {

          }).finally(() => {
            top.location.reload();
          });

        this.setQueryParams();
      }
      //this.Search.vendorCode='TE00001';
      //sessionStorage.setItem('VendorCode', 'TE00001');
      if (this.paramsObject.params._plcvdcd != undefined) {
        let VDCode = this.decryptUsingTripleDES(decodeURI(this.paramsObject.params._plcvdcd));
        sessionStorage.setItem('VendorCode', VDCode);

        let userName = this.decryptUsingTripleDES(decodeURI(this.paramsObject.params._plcvdanym))
        // console.log(this.paramsObject.params.Token.replace(/\s/g, ""));

        sessionStorage.setItem('UserName', userName);
        //console.log(sessionStorage.getItem('UserName'))
        this.Search.vendorCode = VDCode;
        this.setQueryParams();
      }
      this.dataService.setVendorName(sessionStorage.getItem('UserName') != null ? sessionStorage.getItem('UserName').toString() : "");
      if (this.paramsObject.params.taskId != undefined) {
        this.Search.taskId = this.paramsObject.params.taskId;
        this.Search.search = this.paramsObject.params.candidateName;
        this.setQueryParams();
      }
    });
    this.Search.vendorCode = sessionStorage.getItem("VendorCode");
    if (this.IsProcessContinue == false) {
      if (this.dataService.AuthToken != "") {
        this.GetVendorConsultantPackegeList(this.Search, 'forcount', 'forcurrentpackcount');
      }
      else {
        this.dataService.GetAuthToken().subscribe(res => {
          this.dataService.AuthToken = res;
          this.GetVendorConsultantPackegeList(this.Search, 'forcount', 'forcurrentpackcount');
        });
      }
    }
    else {
      this.spinner.show();
    }
  }

  decryptUsingTripleDES(encrypted: any): string {
    //const keyHex = CryptoJS.enc.Utf8.parse(this.key);"iouZQZJx/eCvwv2qJg1UJw=="
    //var k=CryptoJS.enc.Utf8.parse("53c567cc-e5b8-411d-989a-559787634579");
    const key = CryptoJS.MD5("53c567cc-e5b8-411d-989a-559787634579")
    //const iv = CryptoJS.enc.Utf8.parse();
    const mode = CryptoJS.mode.ECB
    const padding = CryptoJS.pad.Pkcs7
    const decrypted = CryptoJS.TripleDES.decrypt(encrypted, key, { mode, padding })
    return decrypted.toString(CryptoJS.enc.Utf8)
  }
  updateEnvelopStatus(envelop_Pid: any) {
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/ReturnMsg?Envelop_Pid=" + envelop_Pid, null)
      .subscribe(res => {
      });
  }
  setQueryParams() {
    const qParams: Params = {};
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: qParams,
      queryParamsHandling: ''
    });
  }
  ResetSearchParameter() {
    // debugger
    this.evMastID = 0;
    this.IsexpandId = 0;
    this.envMastIds = [];
    this.ConsultantModifiedList = [];
    this.ConsultantDocList = [];
    this.PhysicalSignatureDownloadDocList = [];
    this.AdditionalDocsList = [];
    this.DocType = "";
    sessionStorage.removeItem("SelectedTaskID");
    sessionStorage.removeItem("SelectedEnvMstrID");
    this.Search.vendorCode = sessionStorage.getItem("VendorCode");
    this.Search.gcId = null;
    this.Search.taskId = null;
    this.Search.search = null;
    this.GetVendorConsultantPackegeList(this.Search, 'forcount', '');
    // this.getTakeActionPendingDocsCount(this.Search,'value');
    //this.SearchBy.Vendor_code=sessionStorage.getItem("VendorCode");
    //this.GetViewCompletedDocsCount(this.SearchBy);
  }
  alphaNumberOnly(e) {  // Accept only alpha numerics, not special characters 
    if (/^[a-zA-Z0-9_-]*$/.test(e.key)) {
      return true;
    } else {
      e.preventdefault();
      return false;
    }
  }
  onPaste(e) {
    e.preventDefault();
    return false;
  }
  reloadCurrentRoute() {
    let currentUrl = this.route.url;
    console.log(currentUrl);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  IsemailsendWrapPopupOpen: boolean = false;
  IsValidation: boolean = false;
  IsMailBodyError: boolean = false;
  IsMailToError: boolean = false;
  IsMailCCError: boolean = false;
  IsMailSubjectError: boolean = false;

  MailTo: string = "";
  MailCC: string = "";
  MailSubject: string = "";
  MailBody: string = "";
  taskIdForMail: number = 0;
  SendEmailPopup(admin_Email: any, taskId: any, candidatename: any, vendorname: any, i) {
    //debugger;
    this.IsemailsendWrapPopupOpen = !this.IsemailsendWrapPopupOpen;
    if (this.IsemailsendWrapPopupOpen) { this.emailsendWrapStyle = "custom_modal active" }
    else { this.emailsendWrapStyle = "custom_modal" }
    this.IsMailToError = false;
    this.IsMailSubjectError = false;
    this.IsMailBodyError = false;
    if (admin_Email == '') {
      this.MailTo = "";
      this.MailCC = "";
      this.MailSubject = "";
      this.MailBody = "";
      this.taskIdForMail = 0;
      this.IsSendMailBtn = false;
    }
    else {
      this.MailTo = admin_Email;
      this.MailCC = this.Vendor_EmailId;
      this.MailSubject = vendorname + ' - ' + candidatename.split('-')[0];
      this.taskIdForMail = parseInt(taskId);
      let element: HTMLElement = document.getElementById('closePocPopup' + i) as HTMLElement
      element.click();
    }
    this.IsSendMailBtn = false;
  }
  CheckValidation() {
    this.IsValidation = false;
    if (this.MailTo == "") {
      this.IsMailToError = true;
      this.IsValidation = true;
    }
    if (this.MailCC == "") {
      this.IsMailCCError = true;
      this.IsValidation = true;
    }
    if (this.MailSubject == "") {
      this.IsMailSubjectError = true;
      this.IsValidation = true;
    }
    if (this.MailBody == null || this.MailBody == "") {
      this.IsMailBodyError = true;
      this.IsValidation = true;
    }
  }
  IsSendMailBtn: boolean = false;
  SendEmail() {
    // debugger
    this.MailBody = document.getElementById("mailMessage").innerHTML;
    this.CheckValidation();
    if (this.IsValidation) {
      return;
    }
    else {
      this.IsSendMailBtn = true;
    }
    this.Mail = {
      email_Subject: this.MailSubject,
      email_Body: this.MailBody,
      email_From: 'esign@ascendion.com',
      email_To: this.MailTo,
      email_CC: this.MailCC,
      email_BCC: '',
      email_Sent_By: 'Vendor',
      ActivityName: 'Communication Center - Vendor',
      omnE_Service: 'eSign',
      omnE_Entity: 'Inc',
      TaskId: this.taskIdForMail,
      email_Template_Id: 0
    };
    this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/MailFunctionality", this.Mail).subscribe((response: any) => {
      this.toastr.success('Email Sent Successfully.');
      this.spinner.hide();
    },
      error => {
        this.toastr.error('Something went wrong.');
        this.spinner.hide();
      });
    this.SendEmailPopup('', '', '', '', 0)
  }
  getTakeActionPendingDocsCount(search: any, value: any) {
    this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/GetEsignConsultantPendingPackagesCount", search)
      .subscribe(
        (response: any) => {
          //  debugger
          this.dataService.setTakeActionCount(response);
          // console.log(response);
          if (value != 'value') {
            this.SearchBy.Vendor_code = sessionStorage.getItem("VendorCode");
            this.GetViewCompletedDocsCount(this.SearchBy);
          }
        },
        error => {
          console.log(error);
        });
  }
  GetViewCompletedDocsCount(search: any) {
    // debugger;
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetVendorConsultantCompleteDocsCount", search)
      .subscribe((response: any) => {
        //  debugger;
        //console.log(response);
        this.dataService.setVendorViewCompeletedDocsCount(response);
      });
  }
  onClickOnBeginProcess(filename: string = '') {
    if (filename != '') {
      this.IsReviewDivVisible = true;
      if (filename == 'workorder_updated.aspx') {
        this.IsFillableDivVisible = true;
      }
      else if (filename == 'workorder_passthru.aspx') {
        this.IsFillableDivVisibleForSP = true;
      }
      else if (filename == 'workorder_ca.asp' || filename == 'workorder_ca.aspx') {
        this.IsFillableDivVisibleForCN = true;
      }
      this.IsReviewIFrameVisible = false;
      this.IsEsign = false;
      this.IsBeginProcess = true;
    }
  }
  onClickOnEsignProcess() {
    this.IsReviewDivVisible = false;
    this.IsFillableDivVisible = false;
    this.IsReviewIFrameVisible = false;
    //this.OpenDocuSignPopup();
    this.Submit();
  }

  parentFunForWorkOrder(value) {
    //debugger;
    console.log(value);//value is docid
    this.IsReviewDivVisible = false;
    this.IsFillableDivVisible = false;
    this.IsReviewIFrameVisible = false;
    //this.IsEsign = true;
    this.IsBeginProcess = false;
    //this.CurrentEsignDocIndex += 1;
    if (this.CurrentEsignDocIndex < this.CurrentEsignDocLength) {
      this.IsNext = true;
      this.IsWorkOrderReviewed = true;
      this.DocsReviewedCount += 1;
      if (value != 0) {  //0 for rejection
        this.IsEsign = true;
        this.SubmitAndNext();
      }
      else {
        setTimeout(() =>
          this.getOnlineDocsForEsign(''), 1000
        );
        this.IsEsign = false;
      }
    }
    else {
      if (value != 0) {
        this.IsEsign = true;
        this.IsWorkOrderReviewed = true;
        setTimeout(() =>
          this.getOnlineDocsForEsign(''), 1000
        );
      } else {
        this.IsEsign = false;
        setTimeout(() =>
          this.getOnlineDocsForEsign(''), 1000
        );
      }
    }

    // this.ReviewDocuments(this.ConsultantReviewDocList);
  }
  RejectPopupOpen(RejectFrom) {
    if (RejectFrom == 'RejectAndGoNext') { this.ISRejectAndGoNext = true } else { this.ISRejectAndGoNext = false }
    this.IsRejectPopupOpen = !this.IsRejectPopupOpen;
    if (this.IsRejectPopupOpen) { this.RejectPopupclass = "custom_modal notes_modal active" }
    else { this.RejectPopupclass = "custom_modal notes_modal" }
  }
  //not used 
  Reject() {
    if (this.RejectionNotes == '') {
      this.RejectionNotesError = true;
      return true;
    }
    else {
      this.RejectionNotesError = false;
    }

    this.SelectedParams.DocId = this.ConsultantReviewDocList[this.CurrentEsignDocIndex].DocID;
    this.SelectedParams.RejectionReason = this.RejectionNotes;
    this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/RejectDocument", this.SelectedParams)
      .subscribe(res => {
        this.RejectionNotes = "";
      });
    this.CurrentEsignDocIndex += 1;
    if (this.ISRejectAndGoNext) {
      this.ReviewDocuments(this.ConsultantReviewDocList);
    }
    else {
      this.IsReviewDivVisible = false;
      this.IsReviewSubDivVisible = false;
      this.IsReviewIFrameVisible = false;
      this.ConsultantModifiedList = [];
      //this.getConsultantDocList(sessionStorage.getItem('SelectedTaskID'), sessionStorage.getItem('SelectedEnvMstrID'));
    }
    this.RejectPopupOpen('close');
  }


  InsUpdPinOnPackage(envMstrID, taskId, EmailLogId, PinId) {
    //debugger
    this.PinActiverecords.task_id = taskId.toString();
    this.PinActiverecords.envMstrID = envMstrID.toString();
    this.PinActiverecords.EmailLogId = EmailLogId;
    this.PinActiverecords.pinID = PinId;
    this.PinActiverecords.IsActive = PinId == 0 ? true : false;
    this.PinActiverecords.Doc_Type = 'TakeAction';
    //this.pinID=pinID;
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/InsPinVendorCompletedocsActiveRecords", this.PinActiverecords)
      .subscribe((res) => {
        //console.log(res);
        if (res.RowsAffected == 1) {
          this.GetVendorConsultantPackegeList(this.Search, '', '');
        }
      },
        error => {
          console.log(error);
          this.toastr.error(error);
          //this.spinner.hide();
        });
  }
  IsWorkOrderRejected: boolean = false;
  CreateEnvelope(DocList: any, DocCategory?: string, Doc_Sequence?: number, envelop_Pid?: string) {
    //debugger
    this.IsWorkOrderRejected = false;
    // this.IsWorkOrderReviewed==false;
    this.IsReviewDivVisible = false;
    this.IsFillableDivVisible = false;
    this.IsFillableDivVisibleForSP = false;
    this.IsFillableDivVisibleForCN = false;
    this.IsReviewIFrameVisible = false;
    //this.IsEsign = false;
    this.IsBeginProcess = false;
    this.IsEsign = false;
    this.ConsultantReviewDocList = [];
    this.CurrentEsignDocIndex = 0;
    this.DocsReviewedCount = 0;
    sessionStorage.setItem('envelop_Pid', envelop_Pid);
    if (Doc_Sequence != 0) {
      this.CurrentEsignDocIndex = DocList.findIndex(x => x.DocID == Doc_Sequence);
      if (DocList[this.CurrentEsignDocIndex]?.Doc_Status == "Reviewed") {
        this.ReviewDoc = 1;
      }
    }
    // if (this.ReviewDoc == 0) {
    let IsWorkOrder = 0;
    let IsWorkOrderReject = 0;
    DocList.forEach((value, index) => {
      if (value.Doc_Status == 'Pending' || value.Doc_Status == 'Reviewed' || value.Doc_Status == 'Rejected' || value.Doc_Status == 'AdminReject') {
        this.ConsultantReviewDocList.push({ DocID: value.DocID, DocCategory: value.DocCategory, DocName: value.DocName, TemplateID: value.TemplateID, DocuSign_Status: value.DocuSign_Status, FileName: value.FileName, Doc_Status: value.Doc_Status, UploadedFileData: value.UploadedFileData, doc_type: value.doc_type, sign_type: value.sign_type, Consultant_Reject: value.Consultant_Reject });
        if (value.FileName.replace(".asp", ".aspx").replace(".aspxx", ".aspx").split('.').pop() == 'aspx') {
          IsWorkOrder += 1
        }
      }
      if (value.Doc_Status == 'Rejected' || value.Doc_Status == 'AdminReject') {
        IsWorkOrderReject += 1;
      }
    });
    if (IsWorkOrder == 0) {
      this.IsEsign = true;
    }
    if (IsWorkOrderReject == 1) {
      this.IsEsign = false;
      this.IsWorkOrderRejected = true;
    }
    this.CurrentEsignDocLength = this.ConsultantReviewDocList.length - 1;
    if (this.ConsultantReviewDocList.length > 0) {
      this.IsDocSignIFrameVisible = false;
      // this.IsReviewDivVisible = true;
      this.ReviewDocuments(this.ConsultantReviewDocList);
    }
    else {
      this.IsReviewDivVisible = false;//"Signed"
      IsWorkOrderReject == 1 ? this.IsEsign = false : this.IsEsign = true;
      //IsWorkOrderReject == 1 ? this.toastr.info("Workorder is rejected") : '';
    }
  }
  ReviewDocuments(DocList: any) {
    //debugger
    //this.IsReviewDivVisible = true;
    this.spinner.show();
    var filename = DocList[this.CurrentEsignDocIndex]?.FileName.replace(".asp", ".aspx").replace(".aspxx", ".aspx");
    const FileType = filename?.split('.').pop();
    if (FileType == "aspx" && DocList[this.CurrentEsignDocIndex]?.doc_type == "Signature" && (DocList[this.CurrentEsignDocIndex]?.TemplateID == "" || DocList[this.CurrentEsignDocIndex]?.TemplateID == null)) {
      // this.IsReviewSubDivVisible = true;
      this.IsReviewIFrameVisible = false;
      if ((DocList[this.CurrentEsignDocIndex]?.Doc_Status == "Reviewed" || DocList[this.CurrentEsignDocIndex]?.Doc_Status == "Rejected" || DocList[this.CurrentEsignDocIndex]?.Doc_Status == "AdminReject") || this.IsWorkOrderReviewed == true) {
        if (DocList[this.CurrentEsignDocIndex]?.Doc_Status == "Rejected" || DocList[this.CurrentEsignDocIndex]?.Doc_Status == "AdminReject") {
          //this.toastr.info("Workorder is rejected");
          this.IsEsign = false;
          this.IsNext = true;
          this.IsBeginProcess = false;
          // this.IsReviewDivVisible = false;
          // this.IsFillableDivVisible = false;
          // this.IsFillableDivVisibleForSP = false;
          // this.IsFillableDivVisibleForCN = false;
          this.IsReviewIFrameVisible = false;
          this.forWorkOrderTempValue.docID = DocList[this.CurrentEsignDocIndex]?.DocID;
          this.forWorkOrderTempValue.taskId = sessionStorage.getItem('SelectedTaskID');
          this.forWorkOrderTempValue.docStatus = DocList[this.CurrentEsignDocIndex]?.Doc_Status == "Rejected" ? "Rejected" : "AdminReject";
          this.forWorkOrderTempValue.Consultant_Reject = DocList[this.CurrentEsignDocIndex]?.Consultant_Reject;
          if (filename == 'workorder_updated.aspx') {
            this.IsFillableDivVisible = true;
          }
          else if (filename == 'workorder_passthru.aspx') {
            this.IsFillableDivVisibleForSP = true;
          }
          else if (filename == 'workorder_ca.asp' || filename == 'workorder_ca.aspx') {
            this.IsFillableDivVisibleForCN = true;
          }
          this.IsReviewDivVisible = true;

          //this.IsReviewIFrameVisible = false;
        } else {
          this.forWorkOrderTempValue.docID = DocList[this.CurrentEsignDocIndex]?.DocID;
          this.forWorkOrderTempValue.taskId = sessionStorage.getItem('SelectedTaskID');
          this.forWorkOrderTempValue.docStatus = 'Reviewed';
          this.forWorkOrderTempValue.Consultant_Reject = DocList[this.CurrentEsignDocIndex]?.Consultant_Reject;
          this.IsEsign = true;
          this.IsNext = true;
          this.IsBeginProcess = false;
          if (filename == 'workorder_updated.aspx') {
            this.IsFillableDivVisible = true;
          }
          else if (filename == 'workorder_passthru.aspx') {
            this.IsFillableDivVisibleForSP = true;
          }
          else if (filename == 'workorder_ca.asp' || filename == 'workorder_ca.aspx') {
            this.IsFillableDivVisibleForCN = true;
          }
          this.IsReviewDivVisible = true;

          this.IsReviewIFrameVisible = false;
        }

        //this.IsFillableDivVisible=true;
        // if(this.IsWorkOrderReviewed==false){
        //   this.IsBeginProcess = true;
        // }
        // else{
        //   this.toastr.info("Workorder has already reviewed");
        // }
      }
      else {
        this.forWorkOrderTempValue.docID = DocList[this.CurrentEsignDocIndex]?.DocID;
        this.forWorkOrderTempValue.taskId = sessionStorage.getItem('SelectedTaskID');
        this.forWorkOrderTempValue.docStatus = 'Pending';
        this.forWorkOrderTempValue.envelop_Pid = parseInt(sessionStorage.getItem("envelop_Pid"));
        this.forWorkOrderTempValue.Consultant_Reject = DocList[this.CurrentEsignDocIndex]?.Consultant_Reject;
        this.onClickOnBeginProcess(filename);
        this.IsBeginProcess = true;
        this.IsNext = false;
      }
      // this.dataService.Post(environment.eSignApiUrl + "/api/EsignTakeAction/GetEsignDocHtmlFile", null)
      //   .subscribe(
      //     (response: any) => {
      //       if (response != null) {
      //         this.DocHtml = this.sanitizer.bypassSecurityTrustHtml(response.docFile);
      //       }
      //       else {
      //         fetch('../assets/EditDocHtmlFiles/Affirmative_Action_Survey.html')
      //           .then(response => response.text()
      //           )
      //           .then(data => {
      //             if (data != null) {
      //               this.DocHtml = this.sanitizer.bypassSecurityTrustHtml(data.replace("@Signature", "sanjay.kpatel"));

      //             }
      //           })
      //           .catch(error => { });
      //       }
      //     },
      //     error => {
      //     });
    }

    if (FileType == "pdf") {
      //debugger
      this.IsReviewSubDivVisible = false;
      this.IsReviewDivVisible = true;
      this.IsReviewIFrameVisible = true;
      this.IsFillableDivVisible = false;
      this.IsFillableDivVisibleForSP = false;
      this.IsFillableDivVisibleForCN = false;
      this.IsNext = true;
      // this.ReviewDocs();
      // this.convertByteToPdf(DocList[this.CurrentEsignDocIndex]?.UploadedFileData,DocList[this.CurrentEsignDocIndex]?.FileName);
      this.DocsUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://stmetalprodsovren.blob.core.windows.net/omne/Latest_WO_docs/" + DocList[this.CurrentEsignDocIndex]?.FileName);

    }

    this.spinner.hide();
  }
  convertByteToPdf(response: any, filename: string) {
    var fileURL;
    let mimeType;
    const selectedFileType = filename.split('.').pop();
    const FileType = [
      { key: "pdf", value: 'application/pdf', IsDownload: "1" }
    ];

    mimeType = FileType.filter((value) => value.key == selectedFileType);
    if (mimeType.length > 0) {
      this.spinner.show();
      var blob = this.base64ToBlob(response, mimeType[0].value);
      if (mimeType[0].IsDownload == "1") {
        var link = window.document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        fileURL = link;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // this.spinner.hide();
      }
    }

    // let file = new Blob([response], { type: 'application/pdf' });            

    //window.open(fileURL);
    return fileURL;
  }
  Submit() {
    //this.spinner.show();
    this.OpenInfoPopupForEsign();
    this.CurrentEsignDocIndex = 0;
    this.ConsultantTempList;
    this.SelectedReviewDocList = [];
    this.DocType = "";
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetDocuSignResponse?Envelop_Pid=" + sessionStorage.getItem('envelop_Pid'), null)
      .subscribe((res) => {
        this.ConsultantTempList = res;
        // this.spinner.hide();
        //  console.log(this.ConsultantTempList.data.signingUrl)
        this.OpenInfoPopupForEsign();
        this.OpenDocuSignPopup();
        this.DocuSignUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.ConsultantTempList.data.signingUrl);
        // console.log(res)
      });

  }

  Previous() {
    this.CurrentEsignDocIndex -= 1;
    this.ReviewDocuments(this.ConsultantReviewDocList);
  }
  ReviewDocs() {
    //debugger
    this.SelectedParams.DocId = this.ConsultantReviewDocList[this.CurrentEsignDocIndex].DocID;
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/ReviewDocument?Doc_Id=" + this.SelectedParams.DocId, null)
      .subscribe((res: any) => {
        const a = res;
        console.log(a.RowsAffected);
        if (a.RowsAffected == 1) {
          this.DocsReviewedCount += 1;
        }
      });

    if (this.DocsReviewedCount == (this.CurrentEsignDocLength + 1)) {
      this.IsEsign = true;
    }
  }
  SubmitAndNext() {
    this.CurrentEsignDocIndex += 1;
    this.ReviewDocuments(this.ConsultantReviewDocList);
  }

  emailWrapPopup(emailLogId) {
    this.IsemailWrapPopupOpen = !this.IsemailWrapPopupOpen;
    if (this.IsemailWrapPopupOpen) { this.emailWrapStyle[emailLogId] = "custom_modal active" }
    else { this.emailWrapStyle[emailLogId] = "custom_modal" }
  }
  SearchByCandidateandClientName() {
    //debugger
    if (this.Search.search != null && this.Search.search != "") {
      this.evMastID = 0;
      this.envMastIds = [];
      this.ConsultantModifiedList = [];
      this.ConsultantDocList = [];
      this.PhysicalSignatureDownloadDocList = [];
      this.AdditionalDocsList = [];
      this.DocType = "";
      sessionStorage.removeItem("SelectedEnvMstrID");
      sessionStorage.removeItem("SelectedTaskID");
      sessionStorage.removeItem("envelop_Pid");
      this.Search.gcId = null;
      this.Search.taskId = null;
      this.Search.vendorCode = sessionStorage.getItem("VendorCode");
      this.GetVendorConsultantPackegeList(this.Search, 'forcount', '');
      //this.getTakeActionPendingDocsCount(this.Search,'value');
    }
    else {
      this.toastr.info('Fill candidate or client name');
    }

  }
  taskID: number = 0;
  Vendor_EmailId: string = "";
  GetVendorConsultantPackegeList(search: any, value: any, value2: any) {
    // debugger
    this.spinner.show();
    this.envMastIds = [];
    this.evMastID = 0;
    this.taskID = 0;
    this.IsexpandId = 0;
    this.ConsultantDocList = [];
    this.ConsultantModifiedList = [];
    this.VendorConsultantPackegeList = [];
    if (value == 'forcount') {
      this.getTakeActionPendingDocsCount(this.Search, '');
    }
    this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/GetEsignConsultantPackagesList", search)
      .subscribe(
        (response: any) => {
          this.VendorConsultantPackegeList = response;
          // debugger;
          //console.log(this.VendorConsultantPackegeList)
          if (this.VendorConsultantPackegeList.length > 0) {
            this.VendorConsultantPackegeList.forEach((value, index) => {
              this.envMastIds.push({ envMstrID: value.envMstrID });
              if (index == 0) {
                this.evMastID = value.envMstrID
                this.taskID = value.taskId;
                this.Vendor_EmailId = value.vendorEmail;
              }
            });
          }
          if (value2 == 'forcurrentpackcount') {
            this.GetEnvelopCountForCurrentPackage('ForOnePackage');
          }

          if (this.VendorConsultantPackegeList.length > 0) {
            this.getConsultantDocList(this.taskID.toString(), this.evMastID.toString(), 0);
          }
        });
    this.spinner.hide();
  }

  IsSubmitPhysicalSignatureDocBrn: boolean = false;
  OpenphysicalSignatureDocsPopup(DownloadDocID?: any, envelop_Pid?: any, formname: string = '') {
    // this.IsItAdhocDocs = IsItAdhocDocs;
    this.IsSubmitPhysicalSignatureDocBrn = false;
    this.SelectedDownloadDocID = DownloadDocID;
    this.mainPhyDocumentName = formname;
    this.IsphysicalSignatureDocsPopupOpen = !this.IsphysicalSignatureDocsPopupOpen;
    if (this.IsphysicalSignatureDocsPopupOpen) {
      //this.spinner.show();
      this.PhysicalSignatureStyle = "block"
      //this.RefreshPhysicalSignatureUploadedDocList();
    }
    else {
      this.PhysicalSignatureStyle = "none"
      this.IsPhysicalSignatureDocNameValid = true;
      this.ResetPhysicalSignatureDoc();
      //this.getPhysicalSignatureDownloadDocs(sessionStorage.getItem('SelectedTaskID'));
    }
  }
  IsSubmitAdditionalDocBtn: boolean = false;
  OpenAdditionalDocsPopup(DownloadDocID?: any, formname: string = '') {
    //debugger
    this.IsSubmitAdditionalDocBtn = false;
    //this.IsItAdhocDocs = IsItAdhocDocs;
    this.SelectedDownloadDocID = DownloadDocID;
    this.mainAddDocumentName = formname;
    this.IsAdditionalDocsPopupOpen = !this.IsAdditionalDocsPopupOpen;
    if (this.IsAdditionalDocsPopupOpen) {
      // this.spinner.show();
      this.AdditionalPopupStyle = "block"
      //this.RefreshPhysicalSignatureUploadedDocList();
    }
    else {
      this.AdditionalPopupStyle = "none"
      this.IsAdditionalDocNameValid = true;
      this.ResetAdditionalDoc();
      //this.getAdditionalDocs(sessionStorage.getItem('SelectedTaskID'));
    }
  }
  DownloadFile(FileContent, UploadedFileName) {
    if (FileContent == null) {
      var fileNamewithpath = "Latest_WO_docs/" + UploadedFileName
      this.dataService.Get(environment.eSignCommonApiUrl + "DownloadFileFromAzureBlob?FileName=" + fileNamewithpath, null)
        .subscribe(response => {
          this.DownloadUploadedDoc(response.FileData, UploadedFileName);
          FileContent = response.FileData;
        });
    }
    else {
      this.DownloadUploadedDoc(FileContent, UploadedFileName)
    }
  }

  DownloadUploadedDoc(FileContent, UploadedFileName) {
    //debugger
    this.spinner.show();

    let mimeType;
    const selectedFileType = UploadedFileName.split('.').pop();
    const FileType = [
      // { key: "jpg", value: 'image/jpg', IsDownload: "0" },
      // { key: "jpeg", value: 'image/jpeg', IsDownload: "0" },
      // { key: "png", value: 'image/png', IsDownload: "0" },
      { key: "pdf", value: 'application/pdf', IsDownload: "1" },
      // { key: "xlsx", value: 'application/vnd.ms-excel', IsDownload: "1" },
      // { key: "xls", value: 'application/vnd.ms-excel', IsDownload: "1" },
      { key: "doc", value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', IsDownload: "1" },
      { key: "docx", value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', IsDownload: "1" },
      // { key: "msg", value: 'application/vnd.ms-outlook', IsDownload: "1" }
    ];
    if (FileContent != null) {
      mimeType = FileType.filter((value) => value.key == selectedFileType);
      if (mimeType.length > 0) {

        var blob = this.base64ToBlob(FileContent, mimeType[0].value);
        if (mimeType[0].IsDownload == "1") {
          var link = window.document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = UploadedFileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner.hide();
        }
        else {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          this.spinner.hide();
        }
      }
    }

    this.spinner.hide();
  }

  base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    // debugger
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }
  ViewUploadedDocs(FileContent, UploadedFileName) {
    //debugger
    let mimeType;
    const selectedFileType = UploadedFileName.split('.').pop();
    const FileType = [
      { key: "pdf", value: 'application/pdf', IsDownload: "0" },
      { key: "doc", value: 'application/msword', IsDownload: "1" },
    ];

    mimeType = FileType.filter((value) => value.key == selectedFileType);
    if (mimeType.length > 0) {
      //this.spinner.show();
      var blob = this.base64ToBlob(FileContent, mimeType[0].value);
      if (mimeType[0].IsDownload == "1") {
        var link = window.document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = UploadedFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.spinner.hide();
      }
      else {
        var url = window.URL.createObjectURL(blob);
        window.open(url);
        this.spinner.hide();
      }
    }
  }
  DeleteUploadedPhysicalSignatureDoc(index: number, uploadDocID, DocName: string) {
    if (confirm("Are you sure to delete " + DocName + " ?")) {
      if (uploadDocID == undefined) {
        this.UploadedPhysicalSignatureDoc.splice(index, 1);
        this.IsDragDropBtn = false;
        this.totalUploadedPhysicalSignatureDocs = this.UploadedPhysicalSignatureDoc.length;
        const data =
          this.UploadedPhysicalSignatureDoc.find((data) => {
            return data.uploadDocID == undefined
          });
        if (data == undefined) { this.IsphysicalSignatureDocDelAllDis = true; }
      }

    }
  }
  DeleteUploadedAdditionalDoc(index: number, uploadDocID, DocName: string) {
    if (confirm("Are you sure to delete " + DocName + " ?")) {
      if (uploadDocID == undefined) {
        this.UploadedAdditionalDocsList.splice(index, 1);
        this.IsDragDropBtnForAdditional = false;
        // this.totalUploadedPhysicalSignatureDocs = this.AdditionalDocsList.length;
        const data =
          this.UploadedAdditionalDocsList.find((data) => {
            return data.uploadDocID == undefined
          });
        if (data == undefined) { this.IsAdditionalDocDelAllDis = true; }
      }

    }
  }
  UploadPhysicalSignatureDocs() {
    //debugger
    if (this.txtPhysicaleDocumentName == "") {
      //if (this.txtPhysicaleDocumentName == "") {
      this.IsPhysicalSignatureDocNameValid = false;
      //  } else { this.IsPhysicalSignatureTypeValid = true; }
      // if ($("#ddlPhysicalSignature")[0].selectedIndex <= 0) { this.IsPhysicalSignatureDocNameValid = false; } else { this.IsPhysicalSignatureDocNameValid = true; }|| $("#ddlPhysicalSignature")[0].selectedIndex <= 0
    }
    else {
      this.PhysicalSignaturefileUpload.nativeElement.click()
    }
  }
  UploadAdditionalDocs() {
    if (this.txtAdditionalDocumentName == "") {
      // if (this.txtAdditionalDocumentName == "") {
      this.IsAdditionalDocNameValid = false;
      // } else { this.IsAdditionalDocsTypeValid = true; }
      //  if ($("#ddlAdditional")[0].selectedIndex <= 0) { this.IsAdditionalDocNameValid = false; } else { this.IsAdditionalDocNameValid = true; }|| $("#ddlAdditional")[0].selectedIndex <= 0
    }
    else {
      this.AdditionalfileUpload.nativeElement.click()
    }
  }
  DragDropPhysicalSignatureDocs(files: FileList) {
    //debugger
    this.fileToUpload = files.item(0);
    var fileSizeInMB = this.fileToUpload.size / 1024 / 1024;
    const FileType = this.fileToUpload?.name.split('.').pop();
    if (FileType == "pdf") {
      if (fileSizeInMB <= (environment.maxFileSize + 0.1)) {
        if (this.txtPhysicaleDocumentName == "") {
          // if (this.txtPhysicaleDocumentName == "") {
          this.IsPhysicalSignatureDocNameValid = false;
          // } else { this.IsPhysicalSignatureDocNameValid = true; }
          //if ($("#ddlPhysicalSignature")[0].selectedIndex <= 0) { this.IsPhysicalSignatureDocNameValid = false; } else { this.IsPhysicalSignatureDocNameValid = true; }|| $("#ddlPhysicalSignature")[0].selectedIndex <= 0 this.SelectedPhysicalSignatureDocText.nativeElement.selectedOptions[0].text
        }
        else {
          let CurrentDateTime = new Date();
          let reader = new FileReader();
          reader.readAsDataURL(files.item(0));
          reader.onload = (e) => {
            this.UploadedPhysicalSignatureDoc.push({ docType: this.mainPhyDocumentName, docName: this.txtPhysicaleDocumentName, uploadedDate: CurrentDateTime, uploadedFileData: reader.result.toString().split(',')[1], uploadedFileName: files[0].name, TaskID: sessionStorage.getItem('SelectedTaskID'), doc_id: this.SelectedDownloadDocID, IsItAdhocDocs: this.IsItAdhocDocs, PhyDocsLen: this.PhysicalSignatureDownloadDocList.length })
            this.IsphysicalSignatureDocDelAllDis = false;
            this.IsDragDropBtn = true;
            this.PhysicalSignatureDownloadDocList.forEach((value, index) => {
              if (this.PhysicalSignatureDownloadDocList[index].downloadDocID == this.SelectedDownloadDocID) { this.PhysicalSignatureDownloadDocList[index].totalUploadedDocs += 1 };
            });

            this.txtPhysicaleDocumentName = "";
            CurrentDateTime = null;
            // $("#ddlPhysicalSignature")[0].selectedIndex = 0;
            this.IsPhysicalSignatureDocNameValid = true;
            this.IsPhysicalSignatureTypeValid = true;
            this.PhysicalSignaturefileUpload.nativeElement.value = '';
          }
        }
      }
      else {
        this.toastr.error("File size should not be more than " + environment.maxFileSize + " MB")
      }
    }
    else {
      this.toastr.error("Only PDF file is accepted");
    }


  }
  DragDropAdditionalDocs(files: FileList) {
    this.fileToUpload = files.item(0);
    var fileSizeInMB = this.fileToUpload.size / 1024 / 1024;
    const FileType = this.fileToUpload?.name.split('.').pop();
    if (FileType == "pdf") {
      if (fileSizeInMB <= (environment.maxFileSize + 0.1)) {
        if (this.txtAdditionalDocumentName == "") {
          //if (this.txtAdditionalDocumentName == "") {
          this.IsAdditionalDocNameValid = false;
          // } else { this.IsAdditionalDocsTypeValid = true; }
          // if ($("#ddlAdditional")[0].selectedIndex <= 0) { this.IsAdditionalDocNameValid = false; } else { this.IsAdditionalDocNameValid = true; }|| $("#ddlAdditional")[0].selectedIndex <= 0this.SelectedAdditionalDocText.nativeElement.selectedOptions[0].text
        }
        else {
          let CurrentDateTime = new Date();
          let reader = new FileReader();
          reader.readAsDataURL(files.item(0));
          reader.onload = (e) => {
            this.UploadedAdditionalDocsList.push({ docType: this.mainAddDocumentName, docName: this.txtAdditionalDocumentName, uploadedDate: CurrentDateTime, uploadedFileData: reader.result.toString().split(',')[1], uploadedFileName: files[0].name, TaskID: sessionStorage.getItem('SelectedTaskID'), doc_id: this.SelectedDownloadDocID, IsItAdhocDocs: this.IsItAdhocDocs, PhyDocsLen: this.AdditionalDocsList.length })
            this.IsAdditionalDocDelAllDis = false;
            this.IsDragDropBtnForAdditional = true;
            //this.PhysicalSignatureDownloadDocList.forEach((value, index) => {
            //if (this.PhysicalSignatureDownloadDocList[index].downloadDocID == this.SelectedDownloadDocID) { this.PhysicalSignatureDownloadDocList[index].totalUploadedDocs += 1 };
            //});

            this.txtAdditionalDocumentName = "";
            CurrentDateTime = null;
            //  $("#ddlAdditional")[0].selectedIndex = 0;
            this.IsAdditionalDocNameValid = true;
            this.IsAdditionalDocsTypeValid = true;
            this.AdditionalfileUpload.nativeElement.value = '';
          }
        }
      }
      else {
        this.toastr.error("File size should not be more than " + environment.maxFileSize + " MB")
      }
    }
    else {
      this.toastr.error("Only PDF file is accepted");
    }
  }
  ResetPhysicalSignatureDoc() {
    this.txtPhysicaleDocumentName = "";
    this.UploadedPhysicalSignatureDoc.length = 0;
    this.IsDragDropBtn = false;
    this.PhysicalSignaturefileUpload.nativeElement.value = '';
  }
  ResetAdditionalDoc() {
    this.txtAdditionalDocumentName = "";
    this.UploadedAdditionalDocsList.length = 0;
    this.IsDragDropBtnForAdditional = false;
    this.AdditionalfileUpload.nativeElement.value = '';
  }
  RefreshPhysicalSignatureUploadedDocList() {
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetEsnConsultantPhysicalSignatureUploadDocs?TaskID=" + this.SelectedTaskID + "&DownloadDocID=" + this.SelectedDownloadDocID + "&IsItAdhocDocs=" + this.IsItAdhocDocs, null)
      .subscribe(res => {
        // this.UploadedPhysicalSignatureDoc = res;
        this.totalUploadedPhysicalSignatureDocs = this.UploadedPhysicalSignatureDoc.length;
        this.spinner.hide();
        //this.updatePendingDocCount();
      }, error => { console.log(error); this.spinner.hide(); });
  }
  SubmitPhysicalSignatureDoc() {
    if (this.UploadedPhysicalSignatureDoc.length > 0) {
      this.IsSubmitPhysicalSignatureDocBrn = true;
      this.spinner.show();
      this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/InsUpConsultantPhysicalSignatureUploadDocsDetails", this.UploadedPhysicalSignatureDoc)
        .subscribe(res => {
          //this.toastr.success("Document uploaded successfully", "success", { timeOut: 4000 });
          // this.spinner.show();
          //this.RefreshPhysicalSignatureUploadedDocList();
          this.PhysicalSignatureStyle = "none"
          this.IsDragDropBtn = false;
          this.IsphysicalSignatureDocsPopupOpen = false;
          this.UploadedPhysicalSignatureDoc = [];
          this.spinner.hide();
          this.toastr.success("Document uploaded successfully", "Success");
          setTimeout(() =>
            this.RefreshRecords('Phy'), 1000
          );
        }, error => { this.spinner.hide(); console.log(error); })
      // this.RefreshRecords('Phy');
    }
    else {
      this.toastr.error("There is no document found for Submit", "Error", { timeOut: 4000 });
    }
  }
  SubmitAdditionalDoc() {
    if (this.UploadedAdditionalDocsList.length > 0) {
      this.IsSubmitAdditionalDocBtn = true;
      this.spinner.show();
      this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/InsUpConsultantAdditionalUploadDocsDetails", this.UploadedAdditionalDocsList)
        .subscribe((res) => {
          this.UploadedAdditionalDocsList = [];
          this.IsDragDropBtnForAdditional = false;
          this.IsAdditionalDocsPopupOpen = false;
          //this.RefreshPhysicalSignatureUploadedDocList();
          this.AdditionalPopupStyle = "none"
          this.spinner.hide();
          this.toastr.success("Document uploaded successfully", "Success");
          setTimeout(() =>
            this.RefreshRecords('Add'), 1000
          );
        }, error => { this.spinner.hide(); console.log(error); })

    }
    else {
      this.toastr.error("There is no document found for Submit", "Error", { timeOut: 4000 });
    }
  }
  getPhysicalSignatureDownloadDocs(taskId: string, envMstrID: any) {
    // this.spinner.show();
    this.PhysicalSignatureDownloadDocList = [];
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetESignConsultantPhysicalSignatureDownloadDocs?TaskID=" + taskId + '&envMstrID=' + envMstrID, null)
      .subscribe(res => {
        this.PhysicalSignatureDownloadDocList = res;
        //  this.spinner.hide();
        //  this.updatePendingDocCount();
        //console.log(this.PhysicalSignatureDownloadDocList);
      }, error => { console.log(error); this.spinner.hide(); });
  }
  RefreshRecords(refresh: string) {
    //debugger
    if (refresh == 'Phy') {
      this.getPhysicalSignatureDownloadDocs(sessionStorage.getItem('SelectedTaskID'), sessionStorage.getItem('SelectedEnvMstrID'));
    }
    else {
      this.getAdditionalDocs(sessionStorage.getItem('SelectedTaskID'), sessionStorage.getItem('SelectedEnvMstrID'));
    }
    this.getTakeActionPendingDocsCount(this.Search, '');
    //this.SearchBy.Vendor_code=sessionStorage.getItem("VendorCode");
    //this.GetViewCompletedDocsCount(this.SearchBy);
    this.GetEnvelopCountForCurrentPackage();
  }
  GetEnvelopCountForCurrentPackage(ForOnePackage: any = '') {
    //debugger
    //this.spinner.show();
    if (sessionStorage.getItem('SelectedEnvMstrID') != null && sessionStorage.getItem('SelectedEnvMstrID') != '') {
      this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetEnvelopCountForCurrentPackage?EnvMstrID=" + sessionStorage.getItem('SelectedEnvMstrID'), null)
        .subscribe((res) => {
          //console.log(res);
          debugger
          if (res[0] == 0) {
            sessionStorage.removeItem("SelectedEnvMstrID");
            sessionStorage.removeItem("SelectedTaskID");
            sessionStorage.removeItem("envelop_Pid");
            if (this.VendorConsultantPackegeList.length == (ForOnePackage == 'ForOnePackage' ? 0 : 1)) {
              this.router.navigate(["/viewcompleteddocs"]);
              //, { queryParams: { PackageCountInTakeAction: 1 } }
            } else {
              if (ForOnePackage != 'ForOnePackage') {
                this.reloadCurrentRoute();
              }
            }
          }
        });
    }
  }
  IsexpandId: number = 0;
  rowCollCss: string = "";
  getConsultantDocList(taskId: string, EnvMstrID: string, index) {
    //debugger
    this.IsReviewDivVisible = false;
    this.IsFillableDivVisible = false;
    this.IsFillableDivVisibleForSP = false;
    this.IsFillableDivVisibleForCN = false;
    this.IsReviewIFrameVisible = false;
    this.IsBeginProcess = false;
    this.IsEsign = false;
    this.IsWorkOrderReviewed == false;
    if (this.IsexpandId == parseInt(EnvMstrID)) {
      this.evMastID = 0;
      this.IsexpandId = 0;
      //this.IsCollaspse=false;
      this.ConsultantModifiedList = [];
      this.ConsultantDocList = [];
      this.PhysicalSignatureDownloadDocList = [];
      this.AdditionalDocsList = [];
      this.DocType = "";
      //this.rowCollCss="accordion-body expanded_data ng-star-inserted collapse";
      sessionStorage.removeItem("SelectedTaskID");
      sessionStorage.removeItem("SelectedEnvMstrID");
    }
    else {
      sessionStorage.removeItem("SelectedTaskID");
      sessionStorage.removeItem("SelectedEnvMstrID");
      this.rowCollCss = this.envMastIds[index].envMstrID == this.evMastID ? "accordion-body expanded_data collapse in" : ""
      this.evMastID = parseInt(EnvMstrID);
      this.IsexpandId = parseInt(EnvMstrID);

      // this.rowCollCss="accordion-body expanded_data ng-star-inserted collapse in";
      // this.IsCollaspse=true;
      this.DocType = "";
      this.SelectedTaskID = taskId;
      sessionStorage.setItem('SelectedTaskID', taskId)
      //sessionStorage.setItem('SelectedEnvMstrID', EnvMstrID)
      sessionStorage.setItem('SelectedEnvMstrID', EnvMstrID)
      this.getOnlineDocsForEsign();
      //this.RefreshSupportDocList(taskId);
      this.getPhysicalSignatureDownloadDocs(taskId, sessionStorage.getItem('SelectedEnvMstrID'));
      this.getAdditionalDocs(taskId, sessionStorage.getItem('SelectedEnvMstrID'));
      //this.spinner.hide();
      this.RefreshSupportDocList(taskId, sessionStorage.getItem('SelectedEnvMstrID'), 0, true);
    }
  }
  getOnlineDocsForEsign(value: string = '') {
    this.ConsultantModifiedList = [];
    this.ConsultantDocList = [];
    this.DocType = "";
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetCounsultantPendingDocList?TaskID=" + sessionStorage.getItem('SelectedTaskID') + "&EnvMstrID=" + sessionStorage.getItem('SelectedEnvMstrID'), null)
      .subscribe(res => {
        this.ConsultantDocList = res;
        //  console.log(this.ConsultantDocList);

        this.ConsultantDocList.forEach((value, index) => {
          if (this.DocType != value.doc_Category) {
            this.ConsultantModifiedList.push({ sign_type: value.sign_type, doc_type: value.doc_type, envelop_Pid: value.envelop_Pid, SNO: value.sno, DocCategory: value.doc_Category, DocList: [] });
            //console.log(this.DocType)
            this.DocType = value.doc_Category.trim();
            //console.log(this.DocType);
          }
          let latestIndex: any = this.ConsultantModifiedList.length - 1;
          this.ConsultantModifiedList[latestIndex].DocList.push({ DocID: value.sno, DocCategory: value.doc_Category, DocName: value.actual_Form_Name, TemplateID: value.template_id, DocuSign_Status: value.docuSign_Status, FileName: value.uploadedFileName, Doc_Status: value.doc_status, Doc_Sequence: value.doc_Sequence, UploadedFileData: value.uploadedFileData, doc_type: value.doc_type, sign_type: value.sign_type, Consultant_Reject: value.consultant_Reject, supportingdocscount: value.supportingdocscount, reject_reason: value.reject_Reason });
        });
        //console.log(this.ConsultantModifiedList);

        if (this.ConsultantModifiedList.length > 0) {
          if (value == '') {
            this.CreateEnvelope(this.ConsultantModifiedList[0].DocList, '', 0, this.ConsultantModifiedList[0].envelop_Pid);
          }
        }

      }, error => {
        console.log(error);
      });
  }
  getAdditionalDocs(taskId: string, envMstrID: any) {
    //debugger
    //this.spinner.show();
    this.AdditionalDocsList = [];
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetESignConsultantAdditionalDocs?TaskID=" + taskId + '&envMstrID=' + envMstrID, null)
      .subscribe((res) => {
        if (res != null && res.length > 0) {
          this.sampleAddtionalResObj = res;
        }
        if (this.sampleAddtionalResObj.length > 0) {
          this.AdditionalDocsList = this.sampleAddtionalResObj
        }
        this.sampleAddtionalResObj = [];
      }, error => { console.log(error); this.spinner.hide(); });
    // this.spinner.hide();
  }
  IsSupportingbtndisabled: boolean = false;
  OpenSupportDocPopup(taskId?: number, envMstrID?: number, DocID?: number, DocName?: string) {
    this.IsSupportingDocsForDocId = false;
    this.IsSupportingbtndisabled = false;
    this.UploadedSupportingDocs = [];
    this.DocIdForSupportingDocs = 0;
    this.mainDocumentName = "";
    this.txtDocumentName = "";
    this.fileUpload.nativeElement.value = '';
    this.IssupportingDocsPopupOpen = !this.IssupportingDocsPopupOpen;
    if (this.IssupportingDocsPopupOpen) { this.supportingDocStyle = "block"; this.IsSupportingTypeValid = true; }
    else { this.supportingDocStyle = "none" }
    if (DocID != 0 && DocID != 1) {
      this.IsSupportingDocsForDocId = true;
      this.mainDocumentName = DocName;
      this.DocIdForSupportingDocs = DocID;
      this.RefreshSupportDocList(taskId, 0, DocID, false);
    }
    if (taskId != 1 && DocID == 0) {
      this.RefreshSupportDocList(taskId, envMstrID, 0, true);
    }
    //this.spinner.hide();
  }
  OpenInfoPopupForEsign() {
    this.IsInfoEsignPopupOpen = !this.IsInfoEsignPopupOpen;
    if (this.IsInfoEsignPopupOpen) { this.InfoPopupForEsign = "block" }
    else {
      this.InfoPopupForEsign = "none"
    }
  }
  OpenDocuSignPopup() {
    this.IsDocuSignPopupOpen = !this.IsDocuSignPopupOpen;
    if (this.IsDocuSignPopupOpen) { this.DocuSignPopupStyle = "block" }
    else {
      this.DocuSignPopupStyle = "none"
      this.DocType = "";
      this.IsReviewDivVisible = false;
      this.IsFillableDivVisible = false;
      this.IsReviewIFrameVisible = false;
      this.IsBeginProcess = false;
      this.IsEsign = false;
      this.getOnlineDocsForEsign();
      this.GetEnvelopCountForCurrentPackage();
      //this.reloadCurrentRoute();
    }
    // this.ngOnInit();
  }
  UploadedFile(files: FileList) {
    //debugger
    this.fileToUpload = files.item(0);
    var fileSizeInMB = this.fileToUpload.size / 1024 / 1024;
    const FileType = this.fileToUpload?.name.split('.').pop();
    if (FileType == "pdf") {
      if (fileSizeInMB <= (environment.maxFileSize + 0.1)) {
        let IsSupportDocIndex = false;
        if (this.IsSupportingDocsForDocId == false) {
          IsSupportDocIndex = $("#supportingDoc")[0].selectedIndex <= 0 ? true : false;
        }
        if (this.txtDocumentName == "" || IsSupportDocIndex) {
          if (this.IsSupportingDocsForDocId == false) {
            if (this.txtDocumentName == "") {
              this.IsSupportingDocNameValid = false;
            } else { this.IsSupportingDocNameValid = true; }
            if ($("#supportingDoc")[0].selectedIndex <= 0) { this.IsSupportingTypeValid = false; $("#supportingDoc")[0].selectedIndex = 0; } else { this.IsSupportingTypeValid = true; }
          }
          else {
            if (this.txtDocumentName == "") {
              this.IsSupportingDocNameValid = false;
            } else { this.IsSupportingDocNameValid = true; }
          }
        }
        else {
          let CurrentDateTime = new Date();
          let reader = new FileReader();
          reader.readAsDataURL(files.item(0));
          reader.onload = (e) => {
            this.UploadedSupportingDocs.push({ DocID: this.IsSupportingDocsForDocId == false ? 0 : this.DocIdForSupportingDocs, docType: this.IsSupportingDocsForDocId == false ? this.SelectedDocText.nativeElement.selectedOptions[0].text : this.mainDocumentName, docName: this.txtDocumentName, sent_date: CurrentDateTime, docData: reader.result.toString().split(',')[1], uploadedFileName: files[0].name, TaskID: sessionStorage.getItem('SelectedTaskID'), envMstrID: parseInt(sessionStorage.getItem('SelectedEnvMstrID')), isExist: 0 })
            this.IsSupportingDocDelAllDis = false;
            this.txtDocumentName = "";
            CurrentDateTime = null;
            if (this.IsSupportingDocsForDocId == false) {
              $("#supportingDoc")[0].selectedIndex = 0;
              this.totalUploadedSupportingDocs = this.UploadedSupportingDocs.length;
            }
            else {
              this.totalUploadedSupportingDocsForDocument = this.UploadedSupportingDocs.length;
            }
            this.IsSupportingDocNameValid = true;
            this.IsSupportingTypeValid = true;
            this.fileUpload.nativeElement.value = '';
          }
        }
      }
      else {
        this.toastr.error("File size should not be more than " + environment.maxFileSize + " MB")
      }
    }
    else {
      this.toastr.error("Only PDF file is accepted");
    }
  }
  UploadSupportingDocs() {
    //debugger
    let IsSupportDocIndex = false;
    if (this.IsSupportingDocsForDocId == false) {
      IsSupportDocIndex = $("#supportingDoc")[0].selectedIndex <= 0 ? true : false;
    }
    if (this.txtDocumentName == "" || IsSupportDocIndex) {
      if (this.IsSupportingDocsForDocId == false) {
        if (this.txtDocumentName == "") {
          this.IsSupportingDocNameValid = false;
        } else { this.IsSupportingDocNameValid = true; }
        if ($("#supportingDoc")[0].selectedIndex <= 0) { this.IsSupportingTypeValid = false; $("#supportingDoc")[0].selectedIndex = 0; } else { this.IsSupportingTypeValid = true; }
      }
      else {
        if (this.txtDocumentName == "") {
          this.IsSupportingDocNameValid = false;
        } else { this.IsSupportingDocNameValid = true; }
      }
    }
    else {
      this.fileUpload.nativeElement.click()
    }
  }
  DeleteSupportingDocs(index: number, DocID, DocName: string, id, isExist: number) {
    if (confirm("Are you sure to delete " + DocName + " ?")) {
      //debugger
      let DelCase = 0;//for against the doc
      this.UploadedSupportingDocs.splice(index, 1);
      if (this.IsSupportingDocsForDocId == false) {
        this.totalUploadedSupportingDocs = this.UploadedSupportingDocs.length;
        DelCase = 1;
      }
      // if (this.UploadedSupportingDocs.length > 0) {
      if (isExist != 0) {
        this.spinner.show();
        this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/DeleteSupportingDoc?id=" + id + '&DelCase=' + DelCase, null)
          .subscribe(res => { });
        this.spinner.hide();

        if (DelCase == 0) {
          setTimeout(() =>
            this.getOnlineDocsForEsign('refreshOnlyOnlineDocsdata'), 1000
          );
        }

      }
      //}
      this.toastr.success("Document has deleted successfully", "Success");
      if (this.UploadedSupportingDocs.length == 0) { this.IsSupportingDocDelAllDis = true; }
    }
  }
  ResetSupportingDocs() {
    this.txtDocumentName = "";
    this.fileUpload.nativeElement.value = '';
    this.RefreshSupportDocList(this.SelectedTaskID, sessionStorage.getItem('SelectedEnvMstrID'), this.DocIdForSupportingDocs, this.IsSupportingDocsForDocId == false ? true : false);
  }
  RefreshSupportDocList(taskId: any, envMstrID: any, doc_id: number, IsOtherSupportingDocs: boolean) {
    this.spinner.show();
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetConsultantSupportingDocList?TaskID=" + taskId + '&Doc_Id=' + doc_id + '&envMstrID=' + envMstrID, null)
      .subscribe(res => {
        this.UploadedSupportingDocs = res;
        if (IsOtherSupportingDocs == true) {
          this.totalUploadedSupportingDocs = this.UploadedSupportingDocs.length;
        }
        else {
          this.totalUploadedSupportingDocsForDocument = this.UploadedSupportingDocs.length;
        }
        this.spinner.hide();
        this.updatePendingDocCount();
      }, error => {
        this.spinner.hide(); console.log(error);
      });
  }
  updatePendingDocCount() {
    this.totalPendingDocs = 0;
    this.PhysicalSignatureDownloadDocList.map((value) => {
      if (value.totalUploadedDocs == 0) {
        this.totalPendingDocs += 1;
      }
    });
    this.totalPendingDocs = this.totalPendingDocs + this.ConsultantModifiedList.length;
    this.dataService.TakeActionPendingDocs.next(this.totalPendingDocs);
  }
  SubmitSupportingDocs() {
    // debugger
    this.IsSupportingbtndisabled = true;
    var data = this.UploadedSupportingDocs.find((value, index) => {
      return value?.docID == undefined
    })
    if (this.UploadedSupportingDocs.length > 0) {
      if (data == undefined) {
        this.toastr.clear();
        this.toastr.error("Please upload supporting documents", "Error", { timeOut: 4000 });
      } else {
        this.spinner.show();
        this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/InsUpdateSupportingDocsDetails", this.UploadedSupportingDocs)
          .subscribe(res => {
            this.toastr.success("Support documents uploaded successfully", "Success");
            //this.spinner.show();

            if (this.IsSupportingDocsForDocId == true) {
              this.OpenSupportDocPopup(1, 0, 1, '');
              this.spinner.hide();
              setTimeout(() =>
                this.getOnlineDocsForEsign('refreshOnlyOnlineDocsdata'), 1000
              );
            }
            else {
              this.OpenSupportDocPopup(1, 0, 1, '');
              this.RefreshSupportDocList(sessionStorage.getItem('SelectedTaskID'), sessionStorage.getItem('SelectedEnvMstrID'), 0, this.IsSupportingDocsForDocId == false ? true : false);
            }
            //this.spinner.hide();
          }, error => { this.spinner.hide(); console.log(error); })
      }
    }
    else {
      this.toastr.error("There is no document found for Submit", "Error", { timeOut: 4000 });
    }
  }
  RejectionInfoPopup(DocID: any, event) {
    this.RejectionInfoPopupOpen = !this.RejectionInfoPopupOpen;
    if (this.RejectionInfoPopupOpen) {
      //Rejection Notes for OPS & CNS
      this.RejectionHistory = [];
      //this.RejectionHistoryCNS = [];
      this.RejectionHistoryOPS = [];
      this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetRejectionNotes?Doc_Id=" + DocID, null)
        .subscribe(
          (response: any) => {
            this.RejectionHistory = response;
            this.RejectionHistory.forEach((value, index) => {
              //var a = value.RejectionSource;
              //if (value.rejectionSource == "CNS") {
              //  this.RejectionHistoryCNS.push({ ActivityDate: value.activityDate, Reject_Reason: value.reject_Reason, RejectedBy: value.rejectedBy, RejectedDate: value.rejectedDate });
              //}
              //else if (value.rejectionSource == "OPS") {
              this.RejectionHistoryOPS.push({ Reject_Reason: value.reject_Reason, RejectedBy: value.rejected_by, RejectedDate: value.rejectedDate });
              // }
            })
            // this.RejectionInfoPopupclass = "custom_modal notes_modal active";
            event.target.closest('.has-popover').classList.add('active');
          });
    }
    else {
      this.RejectionHistory = [];
      //this.RejectionHistoryCNS = [];
      this.RejectionHistoryOPS = [];
      // this.RejectionInfoPopupclass = "custom_modal notes_modal";
      event.target.closest('.has-popover').classList.remove('active');
    }
  }
}
